import { egyetemUrl } from './landing';

/* ══════════════════════════════════════════════════════════════════════════
   VISSZATÉRÉS A REGISZTRÁCIÓ UTÁN (döntési gyakorló, 3. kör)
   ─────────────────────────────────────────────────────────────────────────
   Az egyetem bemutatójának regisztrációs gombja ide hoz:
     terminal.web3kurzus.hu/?w3k_return=/gyakorlo
   A belépés útja ugyanaz (EmailGate → magic link → /auth/callback), csak a
   sikeres belépés után az AuthCallback nem a terminált nyitja, hanem az
   egyetem gyakorlóját, a session átadásával.

   Nyitott átirányítás nincs: a cél csak egy egyetemi ÚTVONAL lehet az
   engedélylistáról (/gyakorlo és egyszintű alútjai), sosem teljes URL; az
   alap mindig az egyetem (EGYETEM_URL). Paraméter nélkül semmi nem változik.
   A cél a localStorage-ban vár (a magic link általában új fülben nyílik), 2 óráig.

   3b: a cél a belépő link visszahívási címébe is bekerül
   (/auth/callback?w3k_return=/gyakorlo), így ha a link MÁSIK böngészőben nyílik
   (YouTube-, Gmail-alkalmazás), ott is a gyakorló jön: az induláskori
   captureReturn() a visszahívási címen is lefut. Csak a REDIRECT_RETURN_PATHS
   értékei kerülhetnek a címbe — ezek szerepelnek a Supabase átirányítási
   engedélylistáján is PONTOS címként; más cím ott a Site URL-re esne vissza.
   ══════════════════════════════════════════════════════════════════════════ */

const KEY = 'w3k_return';
const PARAM = 'w3k_return';
const TTL_MS = 2 * 3600 * 1000;
// /gyakorlo és egyszintű alútjai; olvasó (1. kör): /olvaso/<slug>; alakzatfelismerő (1. kör): /alakzatfelismero;
// gyertyaminta-felismerő (1. kör): /gyertyafelismero
const ALLOWED = /^\/(?:gyakorlo(?:\/[a-z0-9-]{1,20})?|olvaso\/[a-z0-9-]{1,60}|alakzatfelismero|gyertyafelismero)$/;
// A visszahívási címbe csak ezek kerülhetnek (a Supabase engedélylistáján: a /gyakorlo, az /alakzatfelismero
// és a /gyertyafelismero pontos címként, az /olvaso/<slug> a …?w3k_return=/olvaso/* mintával).
export const REDIRECT_RETURN_PATHS = ['/gyakorlo', '/alakzatfelismero', '/gyertyafelismero'];
const REDIRECT_RETURN_RE = /^\/olvaso\/[a-z0-9-]{1,60}$/;
const inRedirect = (path) => REDIRECT_RETURN_PATHS.includes(path) || REDIRECT_RETURN_RE.test(path);

export const isAllowedReturn = (path) => typeof path === 'string' && ALLOWED.test(path);

/** Induláskor: a ?w3k_return= cél eltárolása, ha az engedélylistán van; a címsorból kikerül. */
export function captureReturn(now = Date.now()) {
  try {
    const url = new URL(window.location.href);
    const path = url.searchParams.get(PARAM);
    if (path === null) return;
    if (isAllowedReturn(path)) localStorage.setItem(KEY, JSON.stringify({ path, at: now }));
    url.searchParams.delete(PARAM);
    window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
  } catch { /* tiltott tároló: nincs visszatérés, a terminál jön */ }
}

/** A függő cél (vagy null), törlés nélkül — az EmailGate-nek. */
export function pendingReturn(now = Date.now()) {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (!v || !isAllowedReturn(v.path) || !(now - v.at < TTL_MS)) return null;
    return v.path;
  } catch { return null; }
}

/** Sikeres belépés után: a cél (egyszer), vagy null. */
export function takeReturn(now = Date.now()) {
  const path = pendingReturn(now);
  try { localStorage.removeItem(KEY); } catch { /* nem kritikus */ }
  return path;
}

/** Az egyetemi cél a session átadásával; a ?honnan= a mérésnek szól (gyakorló: bemutato, olvasó: regisztracio). */
export const returnUrl = (path, session) =>
  egyetemUrl(`${path}?honnan=${path.startsWith('/olvaso/') ? 'regisztracio' : 'bemutato'}`, session);

/** A belépő link visszahívási címe: alapból a régi (változatlan); bemutatóból
    indulva — ha a függő cél a címbe tehető — a cél is benne van. */
export function emailRedirectFor(origin, now = Date.now()) {
  const base = `${origin}/auth/callback`;
  const path = pendingReturn(now);
  return path && inRedirect(path) ? `${base}?${PARAM}=${path}` : base;
}
